import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import {
  PhoneOutlined,
  MailOutlined,
  PlaceOutlined,
  ScheduleOutlined,
} from "@mui/icons-material";
import { CONTACTS } from "../siteConfig";
import { tokens, radius, shadow } from "../../theme/theme";

// Each block shows its `links` one under another, or plain `value` text.
const BLOCKS = [
  {
    icon: <PhoneOutlined />,
    label: CONTACTS.phones.length > 1 ? "Телефони" : "Телефон",
    links: CONTACTS.phones.map((phone) => ({ value: phone.label, href: "tel:" + phone.href })),
  },
  {
    icon: <MailOutlined />,
    label: "Пошта",
    links: [{ value: CONTACTS.email, href: "mailto:" + CONTACTS.email }],
  },
  // { icon: <PlaceOutlined />, label: "Офіс", value: CONTACTS.address },
  { icon: <ScheduleOutlined />, label: "Графік роботи", value: CONTACTS.hours },
];

export default function ContactsPage() {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 6 } }}>
      <Stack spacing={1.5} sx={{ mb: 4, maxWidth: 640 }}>
        <Typography variant="overline" sx={{ color: tokens.blue600 }}>
          Контакти
        </Typography>
        <Typography variant="h1" sx={{ fontSize: { xs: "2rem", md: "2.6rem" } }}>
          Зв'яжіться з нами
        </Typography>
        <Typography color="text.secondary">
          Не знайшли підхожого варіанту в каталозі? Розкажіть, що шукаєте —
          підберемо квартиру вручну й повідомимо, щойно з'явиться відповідна.
        </Typography>
      </Stack>

      <Grid container spacing={3}>
        {BLOCKS.map((block) => (
          <Grid item xs={12} sm={6} md={3} key={block.label}>
            <Paper
              elevation={0}
              sx={{ p: 3, height: "100%", borderRadius: radius.lg, boxShadow: shadow.sm }}
            >
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  mb: 1.5,
                  borderRadius: radius.md,
                  display: "grid",
                  placeItems: "center",
                  backgroundColor: tokens.blue50,
                  color: tokens.blue600,
                }}
              >
                {block.icon}
              </Box>
              <Typography variant="caption" sx={{ display: "block", mb: 0.4 }}>
                {block.label}
              </Typography>
              {block.links ? (
                block.links.map((link) => (
                  <Link
                    key={link.href}
                    href={link.href}
                    variant="subtitle1"
                    sx={{ display: "block", overflowWrap: "anywhere" }}
                  >
                    {link.value}
                  </Link>
                ))
              ) : (
                <Typography variant="subtitle1">{block.value}</Typography>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper
        elevation={0}
        sx={{
          mt: 4,
          p: { xs: 3, md: 5 },
          borderRadius: radius.xl,
          background: "linear-gradient(135deg, " + tokens.blue700 + ", " + tokens.blue900 + ")",
          color: "#fff",
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography variant="h3" sx={{ color: "#fff", mb: 1 }}>
              Здаєте квартиру?
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.8)", maxWidth: 560 }}>
              Додамо ваш об'єкт до бази, зробимо фото та знайдемо орендаря.
              Ваш номер телефону в каталозі не публікується — усі дзвінки
              приймає агенція.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Stack spacing={1.2} alignItems={{ xs: "flex-start", md: "flex-end" }}>
              {CONTACTS.phones.map((phone) => (
                <Button
                  key={phone.href}
                  href={"tel:" + phone.href}
                  size="large"
                  variant="contained"
                  color="secondary"
                  startIcon={<PhoneOutlined />}
                >
                  {phone.label}
                </Button>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
